import React, { useState } from "react";
import { Col, Button  } from "antd";
import { UserOutlined } from '@ant-design/icons';
import Register from "./Register";
import Login from "./Login";
import "../styles/Auth.less";

const SignIn = () => {

    const [ view, setView ] = useState(false)

    return ( 
        <>
        <Col 
            className="sn_login"
            xs={{  span: 24, offset: 0 }} 
            sm={{  span: 24, offset: 0 }} 
            md={{  span: 19, offset: 2 }} 
            lg={{  span: 14, offset: 5 }}  
            xxl={{ span: 10, offset: 7 }}
            
        >
            <img src="logoXXIV.png" alt="logo" width="100%" />

            { view ? <Register /> : <Login /> }

            <Button
                size="large"
                block
                style={{ backgroundColor: '#0d7cd4', color: '#fff', borderColor: '#0d6ab3', fontWeight: 'bold' }}
                icon={<UserOutlined />}
                onClick={ () => setView(!view) }
                type="default">
                {view ? '¿Ya tienes cuenta ? Iniciar sesión' : '¿No tienes cuenta? Crear nueva cuenta'}
            </Button>
            
            
        </Col>
        <Col 
            xs={{  span: 24, offset: 0 }} 
            sm={{  span: 24, offset: 0 }} 
            md={{  span: 19, offset: 2 }} 
            lg={{  span: 14, offset: 5 }}  
            xxl={{ span: 10, offset: 7 }}
            style={{ marginTop: 20, paddingLeft: 3 }}
        >
            Derechos reservados Simposio Nogal { new Date().getFullYear() } &#xa9;
        </Col>
        </>
    );
};

export default SignIn;
